import { render, staticRenderFns } from "./charts_ad.vue?vue&type=template&id=020d73ce&scoped=true"
import script from "./charts_ad.vue?vue&type=script&lang=js"
export * from "./charts_ad.vue?vue&type=script&lang=js"
import style0 from "./charts_ad.vue?vue&type=style&index=0&id=020d73ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d73ce",
  null
  
)

export default component.exports